import React, { Component } from "react";
import { Card, CardImg, Button } from "reactstrap";
import { isIE, isMobileOnly, isTablet, isMacOs } from 'react-device-detect'
import * as kurentoUtils from "kurento-utils";

import EndScreenshareConfirmationModal from "COMPONENTS/CommonComponents/Modal/Modal";
import BitRateTile from "COMPONENTS/CommonComponents/BitRate/BitRateTile";
import ScreenMaskingContainer from "COMPONENTS/ScreenMasking/ScreenMaskingContainer"

import { wsocket } from "WEBSOCKET/wsocket";
import { getMessage } from "CONFIG/i18n";
import { socketMessage, webRtcMessageId, mediaType } from "WEBSOCKET/constants";
import { USER_ROLES, downloadableModules, COMPONENT_IN_FOCUS, RECORDING_METHOD, FULL_SCREEN_V2_ID } from "../../Utils/Constants";
import {
  isMobile, getTurnServerOptionConfig, getFirstNamebyParticipantId,
  isLandscapeLayout
} from "UTILS/Utility";
import { Modules } from "UTILS/Constants";
import screenfull from 'screenfull';

import ic_screeshare_zoom from "ASSETS/Images/ic_screeshare_zoom.svg";
import ic_screeshare_zoomout from "ASSETS/Images/ic_screeshare_zoomout.svg";
import ic_screensharing_white from "ASSETS/Images/header_center/ic_share_white.svg";
import ic_video_close from "ASSETS/Images/ic_video_close.svg";
import ic_screenshare_download from "ASSETS/Images/ic_download_white.svg";
import ic_minimize from "ASSETS/Images/video_menu/ic_full_screen_stop.svg";
import ic_fullscreen from "ASSETS/Images/video_menu/ic_switch_full_screen_white.svg";

import { headerAction } from "CONFIG/ActionFactory";

import "./ScreenShare.less";

export default class ScreenShare extends Component {
  constructor(props) {
    super(props);
    this.state = {
      screenShareId: null,
      isZoomOut: (!this.shouldShowZoomIcon()),
      showButton: false,
      showEndScreenshareConfirmationModal:false,
      streaming: false,
      isFullScreen: false,
      isScreenShare: false,
      screen: null,
    };
    this.constraints = {
      audio: false,
      video: true
    };
    this.waitScreenShareRtcPeer = 0;
    this.fullScreenChangeHandler = this.fullScreenChangeHandler.bind(this);
    this.needRemoveFullScreenChangeHandler = false;
  }

  getIdSuffix() {
    return this.props.inFullScreenV2Container ? FULL_SCREEN_V2_ID.SUFFIX : '';
  }

  fullScreenChangeHandler = () => {
    if(!screenfull.isFullscreen){
      this.setState({
        isFullScreen : false,
      });
      screenfull.off('change', this.fullScreenChangeHandler );
      this.needRemoveFullScreenChangeHandler = false;
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if(!this.props.isFullScreenV2 ){
      if (this.state.isFullScreen && !prevState.isFullScreen && screenfull.isEnabled){
        screenfull.on('change', this.fullScreenChangeHandler );
        this.needRemoveFullScreenChangeHandler = true;
      }
    }
    // screenshare should be closed while refreshing since user's presenter access is revoked on refresh
    if (this.props.presenterId !== prevProps.presenterId && this.props.presenterId !== this.props.uniqueId &&
      this.props.screenSharingParticipantId === this.props.uniqueId) {
      this.onClose();
    }

    if (this.props.latestUpdatedParticipant && this.props.uniqueId === this.props.presenterId) {
      const { uniqueId } = this.props.latestUpdatedParticipant;
      if (prevProps.admittedParticipants.length > this.props.admittedParticipants.length 
        && this.props.screenSharingParticipantId == uniqueId) {
        this.onClose();
      }
    }

    // when screenshare zoom in make it zoom out when co-browse or snapshot started 
    if(!this.state.isZoomOut && 
      ((this.props.showSnapshot !== prevProps.showSnapshot && this.props.showSnapshot) ||
    (this.props.showCustomerCoBrowse !== prevProps.showCustomerCoBrowse && this.props.showCustomerCoBrowse) ||
    (this.props.snapshotPermissionReply !== prevProps.snapshotPermissionReply &&
      this.props.snapshotPermissionReply && this.props.uniqueId === this.props.snapshoteeId))) {
      this.toggleScreenSharingState();
    }
    
    if (this.shouldShowZoomIcon() && prevProps.componentInFocus === COMPONENT_IN_FOCUS.CANVAS &&
      this.props.componentInFocus === COMPONENT_IN_FOCUS.AUDIO_VIDEO) {
      this.props.setComponentInFocus(COMPONENT_IN_FOCUS.AUDIO_VIDEO);
      this.setState({ isZoomOut: true }, () => {
        this.toggleScreenSharingLayout(false)
      })
    }

    if(this.props.recordingMethod === RECORDING_METHOD.MANUAL
      && this.props.screenSharingParticipantId === this.props.uniqueId
      && this.props.isRecording !== prevProps.isRecording
    ){
      this.sendRecrdingWebsocketMessage(this.props.isRecording);
    }

    if (this.props.runScreenShare && prevProps.runScreenShare !== this.props.runScreenShare) {
      this.invokeGetDisplayMedia();
      headerAction.setRunScreenShare(!this.props.runScreenShare);
    }

    if (prevProps.isScreenMasking !== this.props.isScreenMasking) {
      this.resizeScreenMasking();
    }

    if(!this.props.inFullScreenV2Container) {
      const videoElement = document.getElementById(this.props.screenShareId);
      if ( videoElement ) {
        if ( this.props.isFullScreenV2 && !prevProps.isFullScreenV2 ) {
          videoElement.pause();
          console.log(`screen share has been paused successfully screenShareId=${this.props.screenShareId}`);
        } else if ( !this.props.isFullScreenV2 && prevProps.isFullScreenV2 ) {
          videoElement.play()
          .then(() => 
            console.log(`screen share has been played successfully screenShareId=${this.props.screenShareId}`))
          .catch((error) => 
            console.log(`an error occured while playing screen share, error : ${error && error.message ? error.message : JSON.stringify(error)}`));
          this.resizeScreenMasking();
        }
      }
    }

  }

  playVideoInFullScreenV2Container = () => {
    const video = document.getElementById(this.props.screenShareId);
    video.srcObject = wsocket.screenShareRtcPeer.getRemoteStream();
    video.play()
    .then(() => 
      console.log(`screen share  has been played successfully.`))
    .catch((error) => 
      console.log(`an error occurred while playing screen share, error : ${error && error.message ? error.message : JSON.stringify(error)}`));
  }

  componentDidMount() {
    if (!wsocket.io) return;
    if (this.props.inFullScreenV2Container) {
      if ( this.props.screenSharingParticipantId !== this.props.currentParticipantUniqueId &&
        !this.props.isPeerError() ) {
        if( wsocket.screenShareRtcPeer && 
          wsocket.screenShareRtcPeer.peerConnection &&
          wsocket.screenShareRtcPeer.peerConnection.connectionState == "connected" ) {
          this.playVideoInFullScreenV2Container();
        } else {
          this.waitScreenShareRtcPeer = setInterval( () => {
            if (this.props.isPeerError()) {
              clearInterval(this.waitScreenShareRtcPeer);
              this.waitScreenShareRtcPeer = 0;
              return;
            }
            if ( wsocket.screenShareRtcPeer && 
              wsocket.screenShareRtcPeer.peerConnection &&
              wsocket.screenShareRtcPeer.peerConnection.connectionState == "connected" ) {
              clearInterval(this.waitScreenShareRtcPeer);
              this.playVideoInFullScreenV2Container();
              this.waitScreenShareRtcPeer = 0;
            }
          }, 500);
        }
      }
      return;
    }
    window.addEventListener("resize", () => {
      this.toggleScreenSharingLayout(true);
    });
    if (
      this.props.screenSharingParticipantId ===
      this.props.currentParticipantUniqueId
    ) {
      console.log("ScreenShare-- Send");
      var ua = navigator.userAgent.toLowerCase();
      if (ua.indexOf("safari") != -1) {
        if (ua.indexOf("chrome") > -1) {
          // Chrome
          this.invokeGetDisplayMedia();
        } else {
          // Safari
          this.setState({
            showButton: true
          });
        }
      } else {
        this.invokeGetDisplayMedia();
      }
    } else {
      console.log("ScreenShare-- Receive");
      this.invokeReceiveScreenShareMedia();
    }

    if (isMacOs) {
      headerAction.updateHeaderIconClass(Modules.SCREENSHARE, "moduleIconActive cursorDisabled", " cursorDisabled");
    } else {
      headerAction.updateHeaderIconClass(Modules.SCREENSHARE, "moduleIconActive ", " cursorPointer");
    }

    let mediaElement = document.getElementById(this.props.screenShareId);
    // scroll to screen share video when screen share
    if(!isIE && (isMobileOnly || (isTablet && !this.props.isLandscape))) {
      mediaElement.oncanplay = () => {
        this.setState({
          streaming: true
        });
        let screenShareDiv = document.getElementById("screenShareDiv");
        screenShareDiv && screenShareDiv.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest"
        });
      }
    } else if (isMobileOnly || (isTablet && !this.props.isLandscape)) {
      this.interval = setInterval(()=> {
        let screenShareDiv = document.getElementById("screenShareDiv");
        if(document.getElementById(this.props.screenShareId) 
        && document.getElementById(this.props.screenShareId).videoWidth) {
          this.setState({
            streaming: true
          });
          screenShareDiv && screenShareDiv.scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest"
          });
          clearInterval(this.interval)
        }
      }, 2000)
    } else {
      mediaElement.oncanplay = () => {
        this.setState({
          streaming: true
        });
      }
      let videoElement = document.getElementById(this.props.screenShareId);
      // isIE ? videoElement.width = "100%" : null
      if(videoElement) {
        let videoWidth = videoElement.offsetWidth;
        console.log('videoObject.offsetHeight: ', videoElement.offsetHeight);
        console.log('videoObject.offsetWidth: ', videoElement.offsetWidth);
        isIE ? videoElement.width = videoWidth: null
        isIE ? videoElement.height = videoWidth * 0.5625 : null
      }
    }

    if (this.shouldShowZoomIcon()) {
      this.props.setComponentInFocus(COMPONENT_IN_FOCUS.CANVAS);
      this.toggleScreenSharingLayout(false);
    }

    this.resizeScreenMasking();
    window.addEventListener("resize", this.resizeScreenMasking);
    let screenShareVideo = document.getElementById("screenshare");
    if (screenShareVideo) {
      screenShareVideo.addEventListener("resize", this.resizeScreenMasking);
    }

    if (!this.props.inFullScreenV2Container && this.props.isFullScreenV2 && this.props.putFullScreenV2Target ) {
      this.props.putFullScreenV2Target();
    }
  }
  componentWillUnmount() {
    if (!wsocket.io) return;
    if (this.props.inFullScreenV2Container) {
      if ( 0 != this.waitScreenShareRtcPeer ) {
        clearInterval(this.waitScreenShareRtcPeer);
      }
      return;
    }
    if(this.needRemoveFullScreenChangeHandler) {
      screenfull.off('change', this.fullScreenChangeHandler );
    }
    clearInterval(this.interval)
    headerAction.updateHeaderIconClass(Modules.SCREENSHARE, "moduleIcon", " cursorPointer");

    window.removeEventListener("resize", this.resizeScreenMasking);
    let screenShareVideo = document.getElementById("screenshare");
    if (screenShareVideo) {
      screenShareVideo.removeEventListener("resize", this.resizeScreenMasking);
    }
  }
  invokeReceiveScreenShareMedia = () => {
    let video = document.getElementById(this.props.screenShareId);
    
    let options = {
      remoteVideo: video,
      mediaConstraints: this.constraints,
      onicecandidate: this.onIceCandidate,
      configuration: {
        iceServers: getTurnServerOptionConfig(this.props.turnServer),
        iceTransportPolicy: window._env_.REACT_APP_ICE_TRANSPORT_POLICY || 'all'
      }
    };
    let self = this;
    this.props.clearPeerError();
    wsocket.screenShareRtcPeer = new kurentoUtils.WebRtcPeer.WebRtcPeerRecvonly(
      options,
      function(error) {
        if (error) {
          self.props.putPeerError(error);
          return console.error(error);
        }
        this.generateOffer(self.offerToReceiveVideo);
        self.setState({
          showBitRate: true
        })
      }
    );

    let pc = wsocket.screenShareRtcPeer.peerConnection; 

    pc.ontrack = (event) => {
      console.log("WEBRTC screenshare remote stream id for", 
        getFirstNamebyParticipantId(this.props.admittedParticipants, this.props.screenSharingParticipantId, true), 
        this.props.screenSharingParticipantId,
        event.track.id    
      );
    }

    pc.onconnectionstatechange = (event) => {
      console.log("SCREEN_SHARE", "WEBRTC receive only RTCPeerConnection state for", 
        getFirstNamebyParticipantId(this.props.admittedParticipants, this.props.screenSharingParticipantId, true), 
        this.props.screenShareId, pc.connectionState, pc.getTransceivers());
      switch(pc.connectionState) {
        case "connected": 
        case "completed":
          if(isIE) {
            attachMediaStream(video, wsocket.screenShareRtcPeer.getRemoteStream());
          } else {
            video.srcObject = wsocket.screenShareRtcPeer.getRemoteStream();
          }
          if(!this.props.inFullScreenV2Container) {
            if( !this.props.isFullScreenV2) {
              video.play();
            } else {
              video.pause();
            }
          }
          break;
        case "disconnected":
        case "failed":
        case "closed":
          console.error("SCREEN_SHARE", "WEBRTC receive only RTCPeerConnection state for", 
            getFirstNamebyParticipantId(this.props.admittedParticipants, this.props.screenSharingParticipantId, true), 
            this.props.screenShareId, pc.connectionState, pc.getTransceivers());
          break;
      }
    }
    pc.oniceconnectionstatechange = ev => {
      console.log("SCREEN_SHARE", "WEBRTC receive only IceConnection state for", 
        getFirstNamebyParticipantId(this.props.admittedParticipants, this.props.screenSharingParticipantId, true), 
        this.props.screenShareId, pc.iceConnectionState);
      switch(pc.iceConnectionState) {
        case "disconnected":
        case "failed":
        case "closed":
          console.error("SCREEN_SHARE", "WEBRTC receive only IceConnection state for", 
            getFirstNamebyParticipantId(this.props.admittedParticipants, this.props.screenSharingParticipantId, true), 
            this.props.screenShareId, pc.iceConnectionState);
          break;
      }
    }

  };
  invokeGetDisplayMedia = () => {
    var videoConstraints = {
      aspectRatio: 1.777,
      height: this.props.screenshareBandwidthSettings.bandwidth? 
        this.props.screenshareBandwidthSettings.bandwidth: 
        null,
      frameRate: this.props.screenshareBandwidthSettings.fps,
    }
    let ssConstarints = {
      video: videoConstraints
    };
    if (! this.state.isScreenShare) {
      if (navigator.mediaDevices && navigator.mediaDevices.getDisplayMedia) {
        navigator.mediaDevices
        .getDisplayMedia(ssConstarints)
        .then(this.success)
        .catch(this.error);
      } else if (navigator.getDisplayMedia) {
        navigator
        .getDisplayMedia(ssConstarints)
        .then(this.success)
        .catch(this.error);
      } else if (
        typeof AdapterJS !== "undefined" &&
        AdapterJS.webrtcDetectedBrowser === "IE" &&
        AdapterJS.webrtcDetectedVersion >= 9
      ) {
        videoConstraints = this.props.screenshareBandwidthSettings.bandwidth? {
          mediaSource: ["screen"],
          aspectRatio: 1.777,
          height : {exact: this.props.screenshareBandwidthSettings.bandwidth},
          frameRate: this.props.screenshareBandwidthSettings.fps
        } :  {
          mediaSource: ["screen"],
          aspectRatio: 1.777,
          frameRate: this.props.screenshareBandwidthSettings.fps
        }

        navigator.getUserMedia(
          {
            audio: false,
            video: videoConstraints
          },
          this.success,
          this.error
        );
      } else {
        this.error("No suitable API to get Display Media");
      }
    } else {
      navigator.mediaDevices
      .getDisplayMedia(ssConstarints)
      .then((stream) => {
        const videoTrack = stream.getVideoTracks()[0];
        let pc = wsocket.screenShareRtcPeer.peerConnection; 
        const sender = pc.getSenders().find(function (s) {
          return s.track.kind == videoTrack.kind;
        });
        this.state.screen.getTracks().forEach(track => track.stop());
        videoTrack.onended = () => {
          this.stopScreenShare();
        };    
        sender.replaceTrack(videoTrack);
        let ssVideo = document.getElementById(this.props.screenShareId);
        ssVideo.srcObject = stream;
        this.setState({screen: stream});
      })
    }
  };

  stopMediaTracksOfGivenStream = (stream) => {
    stream && stream.getTracks().forEach(track => {
      track.stop();
    });
    this.state.screen = null;
    let ssVideo = document.getElementById(this.props.screenShareId);
    if(ssVideo){
      ssVideo.srcObject = null;
    }
  }

  success = screen => {
    let ssVideo = document.getElementById(this.props.screenShareId);
    var isIE = /*@cc_on!@*/ false || !!document.documentMode;
    if (isIE) {
      ssVideo = attachMediaStream(ssVideo, screen);
    } else {
      ssVideo.srcObject = screen;
    }
    screen.getVideoTracks()[0].onended = () => {
      this.stopScreenShare();
    };

    let options = {
      videoStream: screen,
      mediaConstraints: this.constraints,
      onicecandidate: this.onIceCandidate,
      configuration: {
        iceServers: getTurnServerOptionConfig(this.props.turnServer),
        iceTransportPolicy: window._env_.REACT_APP_ICE_TRANSPORT_POLICY || 'all'
      }
    };
    let self = this;
    wsocket.screenShareRtcPeer = new kurentoUtils.WebRtcPeer.WebRtcPeerSendonly(
      options,
      function(error) {
        if (error) {
          return console.error(error);
        }
        console.log("WEBRTC Screen share self stream id for", 
          getFirstNamebyParticipantId(self.props.admittedParticipants, self.props.uniqueId, true), 
          self.props.uniqueId,
          screen.id    
        );
        this.generateOffer(self.offerToReceiveVideo);
        self.setState({
          showBitRate: true
        })
      }
    );

    let pc = wsocket.screenShareRtcPeer.peerConnection; 

    pc.onconnectionstatechange = (event) => {
      console.log("SCREEN_SHARE", "WEBRTC send only RTCPeerConnection state for", 
        getFirstNamebyParticipantId(this.props.admittedParticipants, this.props.screenSharingParticipantId, true), 
        this.props.uniqueId, pc.connectionState, pc.getTransceivers());
      switch(pc.connectionState) {
        case "disconnected":
        case "failed":
        case "closed":
          console.error("SCREEN_SHARE", "WEBRTC send only RTCPeerConnection state for", 
            getFirstNamebyParticipantId(this.props.admittedParticipants, this.props.screenSharingParticipantId, true), 
            this.props.uniqueId, pc.connectionState, pc.getTransceivers());
          break;
      }
    }
    pc.oniceconnectionstatechange =ev=> {
      console.log("SCREEN_SHARE", "WEBRTC send only IceConnection state for", 
        getFirstNamebyParticipantId(this.props.admittedParticipants, this.props.screenSharingParticipantId, true), 
        this.props.uniqueId, pc.iceConnectionState);
      switch(pc.iceConnectionState) {
        case "disconnected":
        case "failed":
        case "closed":
          console.error("SCREEN_SHARE", "WEBRTC send only IceConnection state for", 
            getFirstNamebyParticipantId(this.props.admittedParticipants, this.props.screenSharingParticipantId, true), 
            this.props.uniqueId, pc.iceConnectionState);
          break;
      }
    }
    this.setState({
      screen: screen,
      isScreenShare: true
    });
  };
  onIceCandidate = (candidate, wp) => {
    let message = {
      data: {
        category: socketMessage.category.WEBRTC,
        action: webRtcMessageId.ICE_CANDIDATE,
        sessionKey: this.props.sessionKey,
        iceData: {
          candidate: candidate,
          senderId: this.props.screenSharingParticipantId,
          media: mediaType.SCREEN
        },
        isSnapshot: false
      }
    };
    this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, message);
  };

  offerToReceiveVideo = (error, offerSdp, wp) => {
    if (error) return console.error("sdp offer error");
    var message = {
      data: {
        category: socketMessage.category.WEBRTC,
        action: webRtcMessageId.SDP_OFFER,
        sessionKey: this.props.sessionKey,
        sdp: offerSdp,
        senderId: this.props.screenSharingParticipantId,
        media: mediaType.SCREEN,
        isSnapshot: false
      }
    };
    this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, message);
  };

  stopScreenShare = () => {
    console.log("stopScreenShare");
    let message = {
      data: {
        category: socketMessage.category.WEBRTC,
        action: webRtcMessageId.STOP_SCREEN_SHARING,
        sessionKey: this.props.sessionKey,
        media: mediaType.SCREEN
      }
    };
    this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, message);
    this.stopMediaTracksOfGivenStream(this.state.screen);
    this.setState({isScreenShare: false});
  };

  error = e => {
    console.log("Screenshare" + e);
    this.stopScreenShare();
  };

  toggleScreenZoomout = () => {
    this.setState({
      isFullScreen : false,
    })
    screenfull.exit().then(() => {
      this.resizeScreenMasking();
    });
  }
  
  toggleScreenZoomin = async () => {
    if( await this.props.handleFullScreenV2(this) ) {
      return;
    }

    let fullScreenDiv = document.getElementById("fullScreenDiv");
    fullScreenDiv.style.overflow = "hidden"; //#2 feedback vertical scroll
    screenfull.request(fullScreenDiv, { navigationUI: 'hide' }).then(() => {
      this.resizeScreenMasking();
    });
    this.setState({
      isFullScreen : true,
    })
  }

  toggleScreenSharingState = () => {
    if(this.state.isZoomOut == true) {
      this.props.setComponentInFocus(COMPONENT_IN_FOCUS.CANVAS);
    }
    this.setState({isZoomOut: !this.state.isZoomOut}, () => {
      this.toggleScreenSharingLayout(false);
      this.resizeScreenMasking();
    })
  }

  toggleScreenSharingLayout = (onResize=false) => {
    if(!onResize && !this.state.isZoomOut) {
      window.scrollTo(0, 0);
    }
    let ssDiv = document.getElementById("cardBody");
    let whiteBoardDiv = document.getElementById("whiteboardContainer");
    let dashboard = document.getElementById("dashboard");
    let whitboardposition = {}
    let audioVideoDiv = document.getElementById("AudioVideoContainer");
    let audioVideoposition = audioVideoDiv ? audioVideoDiv.getBoundingClientRect() : {}
    let tempWhiteboardposition = whiteBoardDiv ? whiteBoardDiv.getBoundingClientRect() : {}
    if (!isMobile() && audioVideoposition.width > tempWhiteboardposition.width) {
      whitboardposition = audioVideoposition;
    } else {
      whitboardposition = tempWhiteboardposition;
    }
    let videoElement = document.getElementById(this.props.screenShareId)
    if(!ssDiv || !whiteBoardDiv || !whiteBoardDiv){
      return // issue comes up when we close screen share window
    }
    // if (ssDiv.hasAttribute("style")) {
    //   ssDiv.removeAttribute("style");
    // } else {
    //   ssDiv.style.position = "fixed";
    //   ssDiv.style.width = "75%"; //TODO: Calculate
    //   ssDiv.style.top = "5em";
    //   ssDiv.style.left = "0.5em";
    // }
    let zoomOut = this.state.isZoomOut;
    if (zoomOut) {
      ssDiv.className = "cardBody ssDiv1";
      ssDiv.style.width = null;
      ssDiv.style.height = null;
      ssDiv.style.top = null;
      if(videoElement) {
        videoElement.style.width = null;
        videoElement.style.height = null;
        videoElement.style.display = "block";
        videoElement.class = ""
        isIE ? videoElement.width = "99%" : null
        let videoWidth = videoElement.offsetWidth;
        isIE ? videoElement.width = videoWidth: null
        isIE ? videoElement.height = videoWidth * 0.5625 : null
      }
    } else {
      if (isIE) {
        ssDiv.className = "cardBody ssDiv2 cardBodyIE alignItemsCenter";
        ssDiv.style.width = whiteBoardDiv.clientWidth+'px';
        ssDiv.style.height = whiteBoardDiv.clientHeight+'px';
        ssDiv.style.top = whiteBoardDiv.offsetTop+'px';
        ssDiv.style.top = whitboardposition.top+"px";
        if(videoElement) {
          videoElement.style.width = "85%";
          videoElement.style.height = "75%";
          videoElement.style.display = (this.props.screenSharingParticipantId === this.props.currentParticipantUniqueId && !this.props.isViewScreenShare)
            ? "none" 
            : "block";
          videoElement.className = "screenShareVideo horizontalCenter"
        }
      } else {
        ssDiv.className = "cardBody ssDiv2 alignItemsCenter";
        if (isLandscapeLayout(this.props.isLandscape)) {
          let parentElement = whiteBoardDiv.parentElement.parentElement;
          // let parentElementposition = parentElement ? parentElement.getBoundingClientRect() : {};
          let dashboardPosition = dashboard ? dashboard.getBoundingClientRect() : {}
          ssDiv.style.width = whitboardposition.width+"px";
          ssDiv.style.height = dashboardPosition.height+10+"px";
          if(videoElement) {
            this.state.isFullScreen ? videoElement.style.width = "100%" : videoElement.style.width = "100%";
            this.state.isFullScreen ? videoElement.style.height = "100%" : videoElement.style.height = "100%";
            if(this.props.screenSharingParticipantId !== this.props.uniqueId)
              ssDiv.style.maxHeight = videoElement.clientHeight+200+"px";    
            videoElement.style.display = (this.props.screenSharingParticipantId === this.props.currentParticipantUniqueId  && !this.props.isViewScreenShare)
              ? "none" 
              : "block";
          }
        }
        else {
          videoElement.style.width = "100%";
        }
        ssDiv.style.top = whitboardposition.top+"px"
      }
    }
  };

  download = () => {
    this.props.broadcastDownloadAction(downloadableModules.SCREENSHARE);
    var video = document.getElementById(this.props.screenShareId);
    var canvas = document.createElement("canvas");
    var context = canvas.getContext("2d");
    canvas.height = video.clientHeight;
    canvas.width = video.clientWidth;

    if (
      typeof AdapterJS !== "undefined" &&
      AdapterJS.webrtcDetectedBrowser === "IE" &&
      AdapterJS.webrtcDetectedVersion >= 9
    ) {
      const lastFrame = video.getFrame();
      const image = new Image();
      image.onload = () => {
        context.drawImage(image, 0, 0, canvas.width, canvas.height);
        var blob = canvas.msToBlob();
        window.navigator.msSaveBlob(blob, 'dicomimage.png');
      };
      image.onerror = () => {
        console.error("Error Occured");
      }
      if(lastFrame) {
        image.setAttribute("src", "data:image/png;base64," + lastFrame);
      }
    }
    else{
      context.drawImage(video, 0, 0, canvas.width, canvas.height);
      let url = canvas.toDataURL();
      let downloadElement = document.getElementById("screenShareDownload");
      downloadElement.href = url;
      downloadElement.download = "screen_share.png";
    }
  };

  onClose = () => {
    this.stopScreenShare();
  };
  onOpenCloseEndScreenshareConfirmationModal = (modalState) => {
    this.setState({
      showEndScreenshareConfirmationModal: modalState
    })
  }
  shouldShowZoomIcon = () => {
    return isLandscapeLayout(this.props.isLandscape)
      && !(this.props.showSnapshot || (this.props.snapshoteeId && this.props.snapshotPermissionReply))
      && !this.props.showCustomerCoBrowse
  }
  renderRecordingMessage = () => {
    if (!this.props.isRecording || !this.props.videoRecordingMessage
      || this.props.screenSharingParticipantId !== this.props.currentParticipantUniqueId) {
      return;
    }
    return(
      <label className="recordingMassage">
        {this.props.videoRecordingMessage}
      </label>
    )
  }

  sendRecrdingWebsocketMessage = (isStart) => {
    let action = "";
    if (isStart) {
      action = webRtcMessageId.START_RECORDING;
    } else {
      action = webRtcMessageId.STOP_RECORDING;
    }
    const message = {
      data: {
        category: socketMessage.category.WEBRTC,
        action: action,
        sessionKey: this.props.sessionKey,
        media: mediaType.SCREEN,
        recordingTarget: this.props.recordingTarget,
      }
    };
    this.props.sendWebsocketMessage(
      socketMessage.events.MESSAGE,
      message
    );
  }

  resizeScreenMasking = () => {
    let screenMaskingDiv = document.querySelector("#screenShareDiv .screenMaskingDiv");
    if (screenMaskingDiv) {
      if (this.props.isScreenMasking) {
        let fullScreenDiv = document.querySelector('#screenShareDiv .fullScreenDiv');
        if (fullScreenDiv) {
          screenMaskingDiv.style.height = fullScreenDiv.offsetHeight + 2 + 'px';
        }
      } else {
        screenMaskingDiv.style.height = '0px';
      }
    }
    if (wsocket.screenShareRtcPeer) {
      let senders = wsocket.screenShareRtcPeer.peerConnection.getSenders();
      if (senders && senders.length) {
        let sender = senders[0];
        if (sender.track) {
          sender.track.enabled = !this.props.isScreenMasking;
        }
      }
    }
  }

  render() {
    const showMaskDiv = ( ( !this.props.isFullScreenV2 && !this.props.inFullScreenV2Container ) || this.props.inFullScreenV2Container ) ? true : false;

    return (
      <div id={"screenShareDiv" + this.getIdSuffix()} className="screenShareDiv">
        { this.state.showEndScreenshareConfirmationModal ? (
          <EndScreenshareConfirmationModal
            show={true}
            isDoubleButton={true}
            handleNoClick={() => { this.onOpenCloseEndScreenshareConfirmationModal(false) }}
            handleYesClick={() => {
              this.onClose();
            }}
            message={getMessage("END_SCREENSHARE_CONFIRMATION_TEXT")}
          /> 
        ): null}
        <Card className="cardBody displayFlex ssDiv1" id="cardBody">
          {!this.state.isFullScreen && !this.props.isFullScreenV2 && 
          <div className="heading" id="heading">
            <div className="leftHeading align-items-center">
              <CardImg src={ic_screensharing_white} className="iconScreenShare" />
              {
                // Screenshare label will always be shown on small window 
                // and to the presenter only when his screenshare window is small 
                ((!this.state.isZoomOut && this.props.screenSharingParticipantId !==
                  this.props.currentParticipantUniqueId) || this.state.isZoomOut) 
                  && <label className="title"> {getMessage("SCREENSHARE")} </label> 
              }
              {
                // - will be shown on big screenshare window only for non-presenter
                (!this.state.isZoomOut && this.props.screenSharingParticipantId !==
                this.props.currentParticipantUniqueId)
                  && <label className="title mx-0"> - </label>
              }
              { 
                (this.props.screenSharePresenterName && !this.state.isZoomOut) &&
                <span className="title">
                  {getMessage("PRESENTING", {userName: this.props.screenSharePresenterName})}
                </span>
              }
              {this.renderRecordingMessage()}
            </div>
            <div className="rightHeading d-flex flex-row-reverse">
              {this.props.screenSharingParticipantId ===
                this.props.currentParticipantUniqueId && (
                <CardImg
                  src={ic_video_close}
                  className="iconScreenShareClose cursorPointer"
                  title={getMessage("STOP_SCREEN_SHARE")}
                  onClick={()=>this.onOpenCloseEndScreenshareConfirmationModal(true)}
                />
              )}
              {this.shouldShowZoomIcon() &&
                <CardImg
                  src={
                    !this.state.isZoomOut
                      ? ic_screeshare_zoomout
                      : ic_screeshare_zoom
                  }
                  title={!this.state.isZoomOut ? getMessage("ZOOMOUT") : getMessage("ZOOMIN")}
                  className={this.state.streaming
                    ? "iconToggle cursorPointer"
                    : "iconToggle cursorPointer disabledIconOpacity cursorDisabled"}
                  onClick={() => this.state.streaming &&
                    this.toggleScreenSharingState()}
                />
              }
              {this.props.userRole === USER_ROLES.AGENT &&
              this.props.screenSharingParticipantId !== this.props.uniqueId &&
              !this.state.isZoomOut &&
              this.props.isScreenShareDownloadAllowed && (
                <a id="screenShareDownload">
                  <CardImg
                    src={ic_screenshare_download}
                    title={getMessage("DOWNLOAD")}
                    className="iconToggle cursorPointer"
                    onClick={this.download}
                  />
                </a>
              )}
              { window._env_.REACT_APP_SHOW_BITRATE == "true" &&
              !isIE && !this.props.isFullScreenV2 &&
              this.state.showBitRate &&
                <BitRateTile 
                  module={Modules.SCREENSHARE}
                  mediaType = {mediaType.VIDEO}
                  participantUniqueID = {this.props.screenSharingParticipantId}
                  uniqueId = {this.props.uniqueId}
                  wsocketPeer = {wsocket.screenShareRtcPeer}
                  hide={this.state.isZoomOut && true}
                />
              }
              { //Full Screen Icon
                this.props.currentParticipantUniqueId != this.props.screenSharingParticipantId &&
                !this.props.isFullScreenV2 && screenfull.isEnabled && (
                  <CardImg
                    src={ic_fullscreen}
                    title={getMessage("SCREEN_ZOOMIN")}
                    className={this.state.streaming
                      ? "iconToggle cursorPointer"
                      : "iconToggle cursorPointer disabledIconOpacity cursorDisabled"}
                    onClick={() => this.state.streaming &&
                        this.toggleScreenZoomin()}
                  />)
              }
            </div>
          </div>
          }
          {/** Safari has limitation that getDisplayMedia can only be called on some user gesture
           * hence this button has been displayed on safari
           */}
          {this.state.showButton ? (
            <div className="perfectCenter">
              <Button
                className="sendBtn startScreenShareBtn"
                onClick={() => {
                  this.invokeGetDisplayMedia();
                  this.setState({ showButton: false }, () => {
                    this.toggleScreenSharingLayout(false);
                    let mediaElement = document.getElementById(this.props.screenShareId);
                    mediaElement.oncanplay = () => {
                      this.setState({
                        streaming: true
                      });
                    }
                  });
                }}
              >
                {getMessage("START_SCREEN_SHARE")}
              </Button>
            </div>
          ) : (
            <div className = { this.props.screenSharingParticipantId === this.props.currentParticipantUniqueId &&
              !this.props.isViewScreenShare ? "fullScreenDivOffView" : "fullScreenDiv" } id={"fullScreenDiv"+this.getIdSuffix()}>
              {
                this.props.isScreenMasking && (this.props.presenterId === this.props.uniqueId) ? (
                  <div className="presenterMsgDiv">
                    <span className="presenterMsg">
                      {getMessage("YOUR_SCREEN_MASKED")}
                    </span>
                  </div>
                ) : null
              }
              {
                showMaskDiv &&
                  <ScreenMaskingContainer
                    presenterId={this.props.presenterId}
                    uniqueId={this.props.uniqueId}
                  />
              }
              <video
                id={this.props.screenShareId}
                width="100%"
                className= {!this.state.isZoomOut && !this.state.isFullScreen && !this.props.isFullScreenV2 ? "screenShareVideoZoomIn" : "screenShareVideo"}
                muted={true}
                autoPlay
                playsInline
                disablePictureInPicture
              />
              {this.props.currentParticipantUniqueId !=
                  this.props.screenSharingParticipantId && this.state.isFullScreen &&(
                <img
                  src={ic_minimize}
                  style={{filter: 'invert(1)'}} // Temporary measures
                  title={getMessage("SCREEN_ZOOMOUT")}
                  className={this.state.streaming
                    ? "iconToggle cursorPointer positionIconsFullscreen"
                    : "iconToggle cursorPointer positionIconsFullscreen disabledIconOpacity cursorDisabled"}
                  onClick={() => this.state.streaming &&
                    this.toggleScreenZoomout()}
                />)
              }
            </div>
          )}
          {  this.props.screenSharingParticipantId === this.props.currentParticipantUniqueId &&
              !this.props.isViewScreenShare &&
              !this.state.isZoomOut &&
              !this.state.showButton && (
            <div className="perfectCenter">
              <div className="screenShareMsg">
                {getMessage("SCREEN_BEING_SHARED")}
              </div>
            </div>)
          }
          
        </Card>
        
      </div>
    );
  }
}
